import {
  usePlayersStore,
} from "@/stores";
export function updatePlayerHand([index, value]: [number, number]) {
  const playersStore = usePlayersStore();
  const player = playersStore.players[index];
  if (!player) return;

  playersStore.update({
    player,
    property: "raisedHands",
    value,
    isFromSocket: true,
  });
}
